export default "__VITE_ASSET__1a31c5ed__"